var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimesheetActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4455 12.3564C15.8392 12.3564 16.1584 12.6756 16.1584 13.0693V17.5265L18.8011 20.1692C19.0795 20.4476 19.0795 20.899 18.8011 21.1774C18.5227 21.4557 18.0713 21.4557 17.7929 21.1774L14.9415 18.3259C14.8078 18.1922 14.7327 18.0109 14.7327 17.8218V13.0693C14.7327 12.6756 15.0518 12.3564 15.4455 12.3564Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.712871C0 0.319163 0.319163 0 0.712871 0H17.8218C18.2155 0 18.5347 0.319163 18.5347 0.712871V7.36634H17.1089V1.42574H1.42574V19.4851H6.41584V20.9109H0.712871C0.319163 20.9109 0 20.5917 0 20.198V0.712871ZM15.4455 5.70297H3.08911V4.27723H15.4455V5.70297ZM7.84158 11.4059H3.08911V9.9802H7.84158V11.4059Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4456 24.4753C19.3826 24.4753 22.5743 21.2836 22.5743 17.3465C22.5743 13.4095 19.3826 10.2178 15.4456 10.2178C11.5085 10.2178 8.31686 13.4095 8.31686 17.3465C8.31686 21.2836 11.5085 24.4753 15.4456 24.4753ZM15.4456 25.901C20.1701 25.901 24 22.071 24 17.3465C24 12.622 20.1701 8.79208 15.4456 8.79208C10.7211 8.79208 6.89111 12.622 6.89111 17.3465C6.89111 22.071 10.7211 25.901 15.4456 25.901Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimesheetActiveIcon);
export default __webpack_public_path__ + "static/media/timesheet-active-icon.0615aac9e781341ac647ebe4f25ca37f.svg";
export { ForwardRef as ReactComponent };